import {I18n} from "../I18n";
import moment from "moment";

const promoterValidator = lang => {

    return {
        categoryValidator: {
            name: {
                rules: [
                    {
                        test: (value) => {
                            return value && value.trim().length > 0;
                        },
                        message: I18n[lang].THIS_FIELD_CANNOT_BE_EMPTY,
                    },
                ],
                errors: [],
                valid: false,
                state: '',
            },
        },
        sectionValidator: {
            categoryId: {
                rules: [
                    {
                        test: (value) => {
                            return value && value > 0;
                        },
                        message: I18n[lang].THIS_FIELD_CANNOT_BE_EMPTY,
                    },
                ],
                errors: [],
                valid: false,
                state: '',
            },
            name: {
                rules: [
                    {
                        test: (value) => {
                            return value && value.trim().length > 0;
                        },
                        message: I18n[lang].THIS_FIELD_CANNOT_BE_EMPTY,
                    },
                ],
                errors: [],
                valid: false,
                state: '',
            },
        },
        videoValidator: {
            file: {
                rules: [
                    {
                        test: (value) => {
                            return value;
                        },
                        message: I18n[lang].THIS_FIELD_CANNOT_BE_EMPTY,
                    },
                    {
                        test: (value) => {
                            return !value || value.size <= 500000000; //500MB
                        },
                        message: I18n[lang].FILE_SIZE_IS_TOO_LARGE
                            + ". "
                            + I18n[lang].LIMIT
                            + ": 500MB",
                    },
                ],
                errors: [],
                valid: false,
                state: '',
            },
            turnOnTime: {
                rules: [
                    {
                        test: (value) => {
                            return !value
                                || moment(value, 'HH:mm', true).isValid()
                        },
                        message: I18n[lang].INCORRECT_FORMAT,
                    },
                ],
                errors: [],
                valid: true,
                state: '',
            },
            turnOffTime: {
                rules: [
                    {
                        test: (value) => {
                            return !value
                                || moment(value, 'HH:mm', true).isValid()
                        },
                        message: I18n[lang].INCORRECT_FORMAT,
                    },
                ],
                errors: [],
                valid: true,
                state: '',
            },
            minutesBetweenPlays: {
                rules: [
                    {
                        test: (value) => {
                            return !value || (0 < value);
                        },
                        message: I18n[lang].LIMIT + ": 0 < " + I18n[lang].VALUE,
                    },
                ],
                errors: [],
                valid: true,
                state: '',
            },
        },
        settingsValidator: {
            turnOnTime: {
                rules: [
                    {
                        test: (value) => {
                            return !value
                                || moment(value, 'HH:mm', true).isValid()
                        },
                        message: I18n[lang].INCORRECT_FORMAT,
                    },
                ],
                errors: [],
                valid: true,
                state: '',
            },
            turnOffTime: {
                rules: [
                    {
                        test: (value) => {
                            return !value
                                || moment(value, 'HH:mm', true).isValid()
                        },
                        message: I18n[lang].INCORRECT_FORMAT,
                    },
                ],
                errors: [],
                valid: true,
                state: '',
            },
            priceTagUrl: {
                rules: [
                    {
                        test: (value) => !value || value.startsWith("https://"),
                        message: I18n[lang].INCORRECT_FORMAT,
                    },
                ],
                errors: [],
                valid: true,
                state: '',
            },
        },
    }
}
export default promoterValidator;


// WEBPACK FOOTER //
// ./src/helpers/promoterValidator.js